import { ChevronLeft } from "lucide-react";

// "‹ Back to Talent" on desktop, just "‹ Back" on phones (see .back-link in index.css).
export function BackLink({ onClick, label }: { onClick: () => void; label: string }) {
  return (
    <button className="back-link" onClick={onClick}>
      <ChevronLeft size={15} />
      <span className="back-short">Back</span>
      <span className="back-full">{label}</span>
    </button>
  );
}
